import cmsData from 'services/cms-state'
import searchRedirects from 'services/app-state/search'
import ui from 'services/ui-state'
import profile from 'services/app-state/profile'
import personalizedRecommendation from 'services/app-state/personalizedRecommendation'

import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  searchRedirects,
  ui,
  profile,
  cmsData,
  personalizedRecommendation,
})

export default rootReducer



// WEBPACK FOOTER //
// ./stores/root-reducer.js